import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { MenuItem } from 'primeng/api';
import { ISPEDSecurityUser } from '../Models/ISPEDSecurityUser';
import { ISPEDSecurityUserRole } from '../Models/ISPEDSecurityUserRole';
import { ISPEDSecurityUserSite } from '../Models/ISPEDSecurityUserSite';
import { ISitesSubmitParameter } from '../Models/ISitesSubmitParameter';
import { IIepInstance } from '../Models/IIepInstance';
import { IStudentMinimal } from '../Models/IStudentMinimal';
import { ISubstituteServiceProvider } from '../Models/ISubstituteServiceProvider';
import { IAdminPlacement } from '../Models/IAdminPlacement';
import { IFormPermissionToAssess } from '../Models/Forms/IFormPermissionToAssess';
import { IMaintenanceLookupIdNameIsDeleted } from '../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedDuration } from '../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedFrequency } from '../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedCode } from '../Models/IMaintenanceLookupIdNameIsDeleted';
import { MaintenanceLookupTableNameEnum } from '../Models/Enums/IMaintenanceLookupTableNameEnum';
import { IMaintenanceInsertUpdateLookupParameter } from '../Models/IMaintenanceInsertUpdateLookupParameter';
import { IServiceMappingSubmitParameter } from '../Models/IServiceMappingSubmitParameter';
import { IStaffToServiceProviderCategory, IStaffToServiceProviderCategorySubmit } from '../Models/IStaffToServiceProviderCategory';
import { IStarIepServiceStaff } from '../Models/IStarIepServiceStaff';
import { ISPEDSecurityUserRoleModifierSubmit } from '../Models/ISPEDSecurityUserRoleModifierSubmit';


@Injectable()
export class MaintenanceService extends BaseService {

  _baseUrl: string = "";

  constructor(
    protected _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getSPEDSecurityUser(userNameEmail: string): Observable<ISPEDSecurityUser> {
    return this._http.get<ISPEDSecurityUser>(this._baseUrl + "api/Maintenance/GetSPEDSecurityUser" + userNameEmail)
      .map((response: ISPEDSecurityUser) => response as ISPEDSecurityUser)
      .catch(this.handleError);
  }

  getSPEDSecurityRoleForUser(userId: number): Observable<ISPEDSecurityUserRole> {
    return this._http.get<ISPEDSecurityUserRole>(this._baseUrl + "api/Maintenance/GetSPEDSecurityRoleForUser" + userId)
      .map((response: ISPEDSecurityUserRole) => response as ISPEDSecurityUserRole)
      .catch(this.handleError);
  }

  getSPEDSecuritySitesForUser(userId: number): Observable<ISPEDSecurityUserSite[]> {
    return this._http.get<ISPEDSecurityUserSite[]>(this._baseUrl + "api/Maintenance/GetSPEDSecuritySitesForUser" + userId)
      .map((response: ISPEDSecurityUserSite[]) => response as ISPEDSecurityUserSite[])
      .catch(this.handleError);
  }

  getIepInstancesForStudent(localStudentId: string): Observable<IIepInstance[]> {
    return this._http.get<IIepInstance[]>(this._baseUrl + "api/Maintenance/GetIepInstancesForStudent" + localStudentId)
      .map((response: IIepInstance[]) => response as IIepInstance[])
      .catch(this.handleError);
  }
  getStaffToServiceProviderCategory(userId: number): Observable<IStaffToServiceProviderCategory[]> {
    return this._http.get<IStaffToServiceProviderCategory[]>(this._baseUrl + "api/Maintenance/GetStaffToServiceProviderCategory" + userId)
      .map((response: IStaffToServiceProviderCategory[]) => response as IStaffToServiceProviderCategory[])
      .catch(this.handleError);
  }
  getStarIepServiceStaff(userId: number): Observable<IStarIepServiceStaff[]> {
    return this._http.get<IStarIepServiceStaff[]>(this._baseUrl + "api/Maintenance/GetStarIepServiceStaff" + userId)
      .map((response: IStarIepServiceStaff[]) => response as IStarIepServiceStaff[])
      .catch(this.handleError);
  }

  getAdminPlacementsForStudent(localStudentId: string): Observable<IAdminPlacement[]> {
    return this._http.get<IAdminPlacement[]>(this._baseUrl + "api/Maintenance/GetAdminPlacementsForStudent" + localStudentId)
      .map((response: IAdminPlacement[]) => response as IAdminPlacement[])
      .catch(this.handleError);
  }

  getStudentMinimal(localStudentId: string): Observable<IStudentMinimal> {
    return this._http.get<IStudentMinimal>(this._baseUrl + "api/Maintenance/GetStudentMinimal" + localStudentId)
      .map((response: IStudentMinimal) => response as IStudentMinimal)
      .catch(this.handleError);
  }

  getStudentPTAs(localStudentId: string): Observable<IFormPermissionToAssess[]> {
    return this._http.get<IFormPermissionToAssess[]>(this._baseUrl + "api/Maintenance/GetStudentPTAs" + localStudentId)
      .map((response: IFormPermissionToAssess[]) => response as IFormPermissionToAssess[])
      .catch(this.handleError);
  }

  //insertUpdateServiceMapping(mappingData: IServiceMappingSubmitParameter): Observable<ISPEDSecurityUserSite[]> {

  //}

  insertUpdateSPEDSecurityUser(spedSecurityUserDetails: ISPEDSecurityUser): Observable<ISPEDSecurityUser> {
    return this._http.post<ISPEDSecurityUser>(this._baseUrl + 'api/Maintenance/InsertUpdateSPEDSecurityUser', spedSecurityUserDetails)
      .map((response: ISPEDSecurityUser) => response as ISPEDSecurityUser)
      .catch(this.handleError);
  }

  insertUpdateSPEDSecurityUserRole(spedSecurityUserRoleDetails: ISPEDSecurityUserRole): Observable<ISPEDSecurityUserRole> {
    return this._http.post<ISPEDSecurityUserRole>(this._baseUrl + 'api/Maintenance/InsertUpdateSPEDSecurityUserRole', spedSecurityUserRoleDetails)
      .map((response: ISPEDSecurityUserRole) => response as ISPEDSecurityUserRole)
      .catch(this.handleError);
  }

  insertUpdateSPEDSecurityUserSites(sitesSubmitParameter: ISitesSubmitParameter): Observable<ISPEDSecurityUserSite[]> {
    return this._http.post<ISPEDSecurityUserSite[]>(this._baseUrl + 'api/Maintenance/InsertUpdateSPEDSecurityUserSites', sitesSubmitParameter)
      .map((response: ISPEDSecurityUserSite[]) => response as ISPEDSecurityUserSite[])
      .catch(this.handleError);
  }

  insertUpdateStaffToServiceProviderCategory(StaffToServiceProviderCategoryDetails: IStaffToServiceProviderCategorySubmit): Observable<boolean> {
    return this._http.post<boolean>(this._baseUrl + 'api/Maintenance/InsertUpdateProviderCategoryAndStarIepServiceStaff', StaffToServiceProviderCategoryDetails)
      .map((response: boolean) => response as boolean)
      .catch(this.handleError);
  }

  updateStudentDisabilities(studentMinimal: IStudentMinimal): Observable<IStudentMinimal> {
    return this._http.post<IStudentMinimal>(this._baseUrl + 'api/Maintenance/UpdateStudentDisabilities', studentMinimal)
      .map((response: IStudentMinimal) => response as IStudentMinimal)
      .catch(this.handleError);
  }


  getSubstituteServiceProviders(serviceProviderId: number): Observable<ISubstituteServiceProvider[]> {
    return this._http.get<ISubstituteServiceProvider[]>(this._baseUrl + "api/Maintenance/GetSubstituteServiceProviders" + serviceProviderId)
      .map((response: ISubstituteServiceProvider[]) => response as ISubstituteServiceProvider[])
      .catch(this.handleError);
  }


  addSubstituteServiceProvider(substituteServiceProvider: ISubstituteServiceProvider): Observable<ISubstituteServiceProvider> {
    return this._http.post<ISubstituteServiceProvider>(this._baseUrl + "api/Maintenance/AddSubstituteServiceProvider", substituteServiceProvider)
      .map((response: ISubstituteServiceProvider) => response as ISubstituteServiceProvider)
      .catch(this.handleError);
  }

  getServiceProviderSpedServiceIds(serviceProviderId: number): Observable<number[]> {
    return this._http.get<number[]>(this._baseUrl + "api/Maintenance/GetServiceProviderSpedServiceIds" + serviceProviderId)
      .map((response: number[]) => response as number[])
      .catch(this.handleError);
  }

  getServiceProviderCatagoryIds(serviceProviderId: number): Observable<number[]> {
    return this._http.get<number[]>(this._baseUrl + "api/Maintenance/GetServiceProviderCatagoryIds" + serviceProviderId)
      .map((response: number[]) => response as number[])
      .catch(this.handleError);
  }


  getMaintenanceLookupBase(maintenanceLookupTableNameEnum: MaintenanceLookupTableNameEnum): Observable<IMaintenanceLookupIdNameIsDeleted[]> {
    return this._http.post<IMaintenanceLookupIdNameIsDeleted[]>(this._baseUrl + "api/Maintenance/GetMaintenanceLookup", maintenanceLookupTableNameEnum)
      .map((response: IMaintenanceLookupIdNameIsDeleted[]) => response as IMaintenanceLookupIdNameIsDeleted[])
      .catch(this.handleError);
  }

  getMaintenanceLookupDuration(maintenanceLookupTableNameEnum: MaintenanceLookupTableNameEnum): Observable<IMaintenanceLookupIdNameIsDeletedDuration[]> {
    return this._http.post<IMaintenanceLookupIdNameIsDeletedDuration[]>(this._baseUrl + "api/Maintenance/GetMaintenanceLookup", maintenanceLookupTableNameEnum)
      .map((response: IMaintenanceLookupIdNameIsDeletedDuration[]) => response as IMaintenanceLookupIdNameIsDeletedDuration[])
      .catch(this.handleError);
  }

  getMaintenanceLookupFrequency(maintenanceLookupTableNameEnum: MaintenanceLookupTableNameEnum): Observable<IMaintenanceLookupIdNameIsDeletedFrequency[]> {
    return this._http.post<IMaintenanceLookupIdNameIsDeletedFrequency[]>(this._baseUrl + "api/Maintenance/GetMaintenanceLookup", maintenanceLookupTableNameEnum)
      .map((response: IMaintenanceLookupIdNameIsDeletedFrequency[]) => response as IMaintenanceLookupIdNameIsDeletedFrequency[])
      .catch(this.handleError);
  }

  getMaintenanceLookupReferredBy(maintenanceLookupTableNameEnum: MaintenanceLookupTableNameEnum): Observable<IMaintenanceLookupIdNameIsDeletedCode[]> {
    return this._http.post<IMaintenanceLookupIdNameIsDeletedCode[]>(this._baseUrl + "api/Maintenance/GetMaintenanceLookup", maintenanceLookupTableNameEnum)
      .map((response: IMaintenanceLookupIdNameIsDeletedCode[]) => response as IMaintenanceLookupIdNameIsDeletedCode[])
      .catch(this.handleError);
  }

  insertUpdateLookupItem(maintenanceInsertUpdateLookupParameter: IMaintenanceInsertUpdateLookupParameter): Observable<IMaintenanceLookupIdNameIsDeleted> {
    return this._http.post<IMaintenanceLookupIdNameIsDeleted>(this._baseUrl + "api/Maintenance/InsertUpdateLookupItem", maintenanceInsertUpdateLookupParameter)
      .map((response: IMaintenanceLookupIdNameIsDeleted) => response as IMaintenanceLookupIdNameIsDeleted)
      .catch(this.handleError);
  }

  getSPEDSecurityRoleModifiersForUser(spedSecurityUserId: number): Observable<number[]> {
    return this._http.get<number[]>(this._baseUrl + "api/Maintenance/GetSPEDSecurityRoleModifiersForUser" + spedSecurityUserId)
      .map((response: number[]) => response as number[])
      .catch(this.handleError);
  }

  insertUpdateSPEDSecurityUserRoleModifier(spedSecurityUserRoleModifierDetails: ISPEDSecurityUserRoleModifierSubmit): Observable<boolean> {
    return this._http.post<boolean>(this._baseUrl + 'api/Maintenance/InsertUpdateSPEDSecurityUserRoleModifier', spedSecurityUserRoleModifierDetails)
      .map((response: boolean) => response as boolean)
      .catch(this.handleError);
  }

}
